import { BRAND } from "../constants/brand";

const SECTION_LABEL = ({ children }) => (
  <div style={{
    display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 18,
  }}>
    <div style={{ width: 32, height: 1, background: BRAND.gold }} />
    <span style={{
      fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700,
      letterSpacing: "0.28em", color: BRAND.gold, textTransform: "uppercase",
    }}>{children}</span>
  </div>
);

const SectionHeading = ({ children }) => (
  <h2 style={{
    fontFamily: "'Playfair Display', serif", fontWeight: 700,
    fontSize: "clamp(20px, 2.5vw, 28px)", color: BRAND.navy,
    margin: "0 0 20px", lineHeight: 1.3,
  }}>{children}</h2>
);

const BodyText = ({ children, style = {} }) => (
  <p style={{
    fontFamily: "'Barlow', sans-serif", fontSize: 16, color: BRAND.textMid,
    lineHeight: 1.9, margin: "0 0 20px", ...style,
  }}>{children}</p>
);

const PullQuote = ({ children }) => (
  <blockquote style={{
    margin: "40px 0",
    padding: "28px 36px",
    borderLeft: `4px solid ${BRAND.gold}`,
    background: "rgba(0,53,122,0.03)",
    borderRadius: "0 12px 12px 0",
  }}>
    <p style={{
      fontFamily: "'Playfair Display', serif", fontStyle: "italic",
      fontSize: "clamp(17px, 2vw, 21px)", color: BRAND.navy,
      lineHeight: 1.65, margin: 0,
    }}>{children}</p>
  </blockquote>
);

const Divider = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 16, margin: "48px 0" }}>
    <div style={{ flex: 1, height: 1, background: `linear-gradient(90deg, ${BRAND.lightGray}, transparent)` }} />
    <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold }} />
    <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold, opacity: 0.5 }} />
    <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold }} />
    <div style={{ flex: 1, height: 1, background: `linear-gradient(270deg, ${BRAND.lightGray}, transparent)` }} />
  </div>
);

const LayerCard = ({ number, title, children }) => (
  <div style={{
    background: BRAND.white, borderRadius: 16,
    border: `1px solid ${BRAND.lightGray}`,
    overflow: "hidden", marginBottom: 24,
    boxShadow: "0 4px 20px rgba(0,53,122,0.05)",
  }}>
    <div style={{
      background: BRAND.navy, padding: "20px 28px",
      display: "flex", alignItems: "center", gap: 16,
      position: "relative",
    }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: BRAND.gold }} />
      <div style={{
        width: 40, height: 40, borderRadius: "50%",
        border: `2px solid ${BRAND.gold}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Playfair Display', serif", fontWeight: 700,
        fontSize: 16, color: BRAND.gold, flexShrink: 0,
      }}>{number}</div>
      <h3 style={{
        fontFamily: "'Playfair Display', serif", fontWeight: 700,
        fontSize: 18, color: BRAND.white, margin: 0,
      }}>{title}</h3>
    </div>
    <div style={{ padding: "24px 28px" }}>
      <p style={{
        fontFamily: "'Barlow', sans-serif", fontSize: 15,
        color: BRAND.textMid, lineHeight: 1.85, margin: 0,
      }}>{children}</p>
    </div>
  </div>
);

export default function NewsletterLabariumMeaningPage({ setPage }) {
  return (
    <>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(160deg, ${BRAND.navyDeep} 0%, ${BRAND.navyDark} 60%, #0a1f3d 100%)`,
        padding: "100px 40px 80px",
        position: "relative", overflow: "hidden",
      }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, transparent, ${BRAND.gold}, transparent)` }} />
        <div style={{ position: "absolute", top: -120, right: -120, width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,169,110,0.06) 0%, transparent 65%)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: -80, left: -80, width: 400, height: 400, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,169,110,0.04) 0%, transparent 65%)", pointerEvents: "none" }} />

        <div style={{ maxWidth: 860, margin: "0 auto", position: "relative", zIndex: 1 }}>
          {/* Back button */}
          <button
            onClick={() => setPage("newsroom")}
            style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 8, padding: "8px 16px", cursor: "pointer",
              fontFamily: "'Barlow', sans-serif", fontSize: 12, fontWeight: 600,
              letterSpacing: "0.1em", color: "rgba(255,255,255,0.6)",
              marginBottom: 40, transition: "all 0.2s ease",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; e.currentTarget.style.color = BRAND.gold; }}
            onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.color = "rgba(255,255,255,0.6)"; }}
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M10 7H4M6 4L3 7l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            BACK TO NEWSROOM
          </button>

          {/* Meta */}
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
            <span style={{
              background: "rgba(201,169,110,0.15)", color: BRAND.gold,
              fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700,
              letterSpacing: "0.2em", padding: "5px 14px", borderRadius: 6,
              border: "1px solid rgba(201,169,110,0.25)", textTransform: "uppercase",
            }}>Company</span>
            <span style={{
              fontFamily: "'Barlow', sans-serif", fontSize: 12,
              color: "rgba(255,255,255,0.4)",
            }}>May 15, 2026</span>
            <span style={{ color: "rgba(255,255,255,0.2)", fontSize: 12 }}>·</span>
            <span style={{
              fontFamily: "'Barlow', sans-serif", fontSize: 12,
              color: "rgba(255,255,255,0.4)",
            }}>8 min read</span>
          </div>

          <h1 style={{
            fontFamily: "'Playfair Display', serif", fontWeight: 700,
            fontSize: "clamp(30px, 5vw, 54px)", color: BRAND.white,
            lineHeight: 1.15, margin: "0 0 28px",
          }}>
            What Does the Name<br />
            <span style={{ color: BRAND.gold }}>Labarium</span> Mean?
          </h1>

          <p style={{
            fontFamily: "'Barlow', sans-serif", fontSize: "clamp(15px, 1.8vw, 18px)",
            color: "rgba(255,255,255,0.6)", lineHeight: 1.8, maxWidth: 700, margin: 0,
          }}>
            Every element of this brand — the name, the mark, the palette, and the typography — carries deliberate meaning. Nothing is decorative. Everything signifies.
          </p>
        </div>
      </div>

      {/* Article Body */}
      <div style={{ background: BRAND.offWhite, padding: "72px 40px 100px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>

          {/* Intro */}
          <div style={{
            background: BRAND.white, borderRadius: 20,
            border: `1px solid ${BRAND.lightGray}`,
            padding: "44px 52px", marginBottom: 52,
            boxShadow: "0 4px 24px rgba(0,53,122,0.06)",
            position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, bottom: 0, width: 4, background: `linear-gradient(180deg, ${BRAND.gold}, rgba(201,169,110,0.2))` }} />
            <p style={{
              fontFamily: "'Playfair Display', serif", fontStyle: "italic",
              fontSize: "clamp(16px, 1.8vw, 20px)", color: BRAND.navy,
              lineHeight: 1.8, margin: 0,
            }}>
              Ralph Waldo Emerson wrote that "words are also actions, and actions are a kind of word." At Labarium, this is not an aphorism — it is a governing principle.
            </p>
          </div>

          {/* Origin Section */}
          <div style={{ marginBottom: 52 }}>
            <SECTION_LABEL>Our Foundation</SECTION_LABEL>
            <SectionHeading>A Name Recovered, Not Invented</SectionHeading>
            <BodyText>
              Labarium Diagnostic Systems, Inc. was founded with a humble commitment to faithfulness — to patients, to science, to truth, and to a higher calling. The company is guided by moral principles rooted in the Christian faith of its founder, as well as the Christian heritage of Western civilization, expressed not through preaching, but through purpose.
            </BodyText>
            <BodyText>
              We believe that better information creates better decisions, and that better decisions reduce suffering and extend life. That is a sacred mission, worthy of a symbol with sacred origins.
            </BodyText>
            <BodyText>
              The name <strong style={{ color: BRAND.navy }}>Labarium</strong> is not invented. It is recovered — drawn from one of the most consequential moments in Western history.
            </BodyText>
          </div>

          <Divider />

          {/* Historical Origin */}
          <div style={{ marginBottom: 52 }}>
            <SECTION_LABEL>Historical Origin</SECTION_LABEL>
            <SectionHeading>The Labarum of Constantine</SectionHeading>

            <div style={{
              display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 28,
            }}
              className="two-col"
            >
              {[
                { label: "Latin Origin", value: "labarum" },
                { label: "Greek Origin", value: "λάβαρον" },
                { label: "Type of Standard", value: "Imperial Vexillum" },
                { label: "Symbol Borne", value: "Chi-Rho Christogram (☧)" },
              ].map(item => (
                <div key={item.label} style={{
                  background: BRAND.white, borderRadius: 12,
                  border: `1px solid ${BRAND.lightGray}`,
                  padding: "20px 24px",
                }}>
                  <div style={{
                    fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700,
                    letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 6, textTransform: "uppercase",
                  }}>{item.label}</div>
                  <div style={{
                    fontFamily: "'Playfair Display', serif", fontSize: 18,
                    color: BRAND.navy, fontWeight: 600,
                  }}>{item.value}</div>
                </div>
              ))}
            </div>

            <BodyText>
              The <em>labarum</em> was the imperial military standard created by the Roman Emperor Constantine I in the early 4th century AD. It was a vexillum — a cavalry battle standard — modified to bear the Chi-Rho christogram: the superimposed Greek letters Chi (Χ) and Rho (Ρ), the first two letters of the Greek word ΧΡΙΣΤΟΣ (Christos), meaning "Christ."
            </BodyText>

            <BodyText>
              The origin of the labarum is inseparable from the <strong style={{ color: BRAND.navy }}>Battle of Milvian Bridge (Ponte Milvio)</strong>, fought on October 28, 312 AD, between Constantine I and the rival emperor Maxentius. The Tiber River bridge, which stands in Rome to this day, became the site of a confrontation that altered the course of civilization.
            </BodyText>
          </div>

          {/* Sacred Vision */}
          <div style={{
            background: `linear-gradient(150deg, ${BRAND.navyDeep}, ${BRAND.navyDark})`,
            borderRadius: 20, padding: "44px 52px", marginBottom: 52,
            position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, ${BRAND.gold}, rgba(201,169,110,0.2))` }} />
            <div style={{ position: "absolute", bottom: -60, right: -60, width: 240, height: 240, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,169,110,0.06) 0%, transparent 65%)" }} />
            <div style={{ position: "relative", zIndex: 1 }}>
              <SECTION_LABEL>The Sacred Vision</SECTION_LABEL>
              <h2 style={{
                fontFamily: "'Playfair Display', serif", fontWeight: 700,
                fontSize: "clamp(20px, 2.5vw, 26px)", color: BRAND.white,
                margin: "0 0 20px",
              }}>October 28, 312 AD</h2>
              <p style={{
                fontFamily: "'Barlow', sans-serif", fontSize: 15,
                color: "rgba(255,255,255,0.75)", lineHeight: 1.85, margin: "0 0 20px",
              }}>
                According to the historian Lactantius, on the eve of battle, Christ appeared to Constantine in a dream and instructed him to use the sign against his enemies. Constantine obeyed. The Chi-Rho was emblazoned on shields, standards, helmets, coins, and public buildings throughout the Roman Empire.
              </p>
              <p style={{
                fontFamily: "'Barlow', sans-serif", fontSize: 15,
                color: "rgba(255,255,255,0.75)", lineHeight: 1.85, margin: "0 0 24px",
              }}>
                Constantine won the battle decisively. Maxentius drowned in the Tiber during the retreat. Constantine entered Rome in triumph, and from that moment forward the labarum became the official imperial standard of the Roman Empire.
              </p>
              <div style={{
                background: "rgba(201,169,110,0.12)", borderRadius: 12,
                border: "1px solid rgba(201,169,110,0.2)", padding: "18px 24px",
              }}>
                <p style={{
                  fontFamily: "'Playfair Display', serif", fontStyle: "italic",
                  fontSize: 15, color: BRAND.gold, lineHeight: 1.75, margin: 0,
                }}>
                  In 313 AD, Constantine and co-emperor Licinius issued the Edict of Milan — granting religious freedom throughout the Roman Empire and marking the beginning of Christianity's transformation from a persecuted sect to the dominant faith of Western civilization.
                </p>
              </div>
            </div>
          </div>

          {/* From Labarum to Labarium */}
          <div style={{ marginBottom: 52 }}>
            <SECTION_LABEL>Etymology</SECTION_LABEL>
            <SectionHeading>From Labarum to Labarium</SectionHeading>
            <BodyText>
              The company name <strong style={{ color: BRAND.navy }}>Labarium</strong> is a deliberate and meaningful adaptation of <em>labarum</em>. The modification is both phonetic and symbolic.
            </BodyText>

            <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 28 }}>
              {[
                {
                  label: "The Latin Root",
                  text: "Labarum connects the company name to its ancient origin — the imperial standard of faith carried into battle.",
                },
                {
                  label: 'The Suffix "-ium"',
                  text: 'Evokes the naming convention of chemical elements and scientific institutions — anchoring the ancient symbol in the language of modern science and medicine.',
                },
                {
                  label: "The Double Meaning",
                  text: 'Labarium reads simultaneously as a reference to the laboratory (Latin: laboratorium — "a place for work") and to the labarum — fusing the sacred and the scientific in a single word.',
                },
              ].map(item => (
                <div key={item.label} style={{
                  display: "flex", gap: 20, alignItems: "flex-start",
                  background: BRAND.white, borderRadius: 12,
                  border: `1px solid ${BRAND.lightGray}`,
                  padding: "20px 24px",
                }}>
                  <div style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: BRAND.gold, flexShrink: 0, marginTop: 6,
                  }} />
                  <div>
                    <div style={{
                      fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700,
                      letterSpacing: "0.15em", color: BRAND.navy, marginBottom: 6, textTransform: "uppercase",
                    }}>{item.label}</div>
                    <p style={{
                      fontFamily: "'Barlow', sans-serif", fontSize: 14,
                      color: BRAND.textMid, lineHeight: 1.75, margin: 0,
                    }}>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <PullQuote>
              "This is not a coincidence. It is the thesis of the company: that faith and science, purpose and precision, ancient wisdom and next-generation technology are not opposites. They are the same mission, expressed across different centuries."
            </PullQuote>

            <BodyText>
              Whether truth comes from a scientific laboratory or by revelation from God, it is compatible. There is no conflict between science and religion. Conflict only arises from an incomplete knowledge of either science or religion — or both.
            </BodyText>
            <BodyText>
              Meanwhile, there will always be more to learn, especially when analyzing data that relates to physiology and the laws of life. Why? Because life comes from God and God lives. There will always be a gap between what He knows and what we now know. Thus, a living God provides modern-day revelation.
            </BodyText>
          </div>

          <Divider />

          {/* The Mark */}
          <div style={{ marginBottom: 52 }}>
            <SECTION_LABEL>Brand Identity</SECTION_LABEL>
            <SectionHeading>The Labarium Mark — Three Layers of Meaning</SectionHeading>
            <BodyText>
              The Labarium mark is a composite symbol containing three distinct layers of meaning, each invisible to a casual glance but fully present for those who know to look. This is intentional. Great symbols do not explain themselves. They reveal themselves over time to those who engage with them.
            </BodyText>

            <LayerCard number="I" title="The Chi-Rho (Labarum Symbol)">
              At the core of the mark is the Chi-Rho (☧) — the ancient christogram of Constantine's labarum. The Chi (X) is rendered as the bold diagonal crossbars that form the center of the mark. The Rho (P) rises upward from the intersection, its vertical staff and curved bowl giving the mark its primary vertical axis. Together, Chi and Rho form the exact symbol that Constantine ordered painted on his soldiers' shields before the Battle of Milvian Bridge in 312 AD. In the Labarium mark, this christogram is present but abstracted — reverent rather than explicit, a signature rather than a sermon. It speaks directly to those with eyes to see it, without requiring explanation from those who do not.
            </LayerCard>

            <LayerCard number="II" title='The Dx Monogram — "Diagnostics"'>
              The Rho of the Chi-Rho is intentionally rendered to read simultaneously as the letter "D" — creating the medical abbreviation "Dx," the universal shorthand for "diagnostics" used by clinicians worldwide. Together, the D (from the Rho) and the X (from the Chi) form "Dx" — a second layer of meaning visible to any healthcare professional without any explanation required. This double-read — Chi-Rho and Dx simultaneously — is the conceptual cornerstone of the logo: a mark that speaks in two languages at once — the language of ancient faith and the language of modern medicine — without contradiction.
            </LayerCard>

            <LayerCard number="III" title="The Diagnostic Code">
              Below the Chi-Rho/Dx intersection, the vertical staff of the mark descends and fans into a cluster of vertical bars of varying heights — referencing simultaneously: genomic sequencing data (the visual language of DNA analysis and next-generation sequencing panels), laboratory reference ranges (the graduated columns of a clinical data visualization), barcode / data encoding (the fundamental language of information systems), and the Vexillum banner (on the historical labarum, a purple cloth banner hung from the crossbar — these descending bars are the Labarium mark's interpretation of that ancient banner, now rendered in the vocabulary of data science).
            </LayerCard>

            <div style={{
              background: BRAND.white, borderRadius: 12,
              border: `1px solid ${BRAND.lightGray}`,
              padding: "24px 28px", marginTop: 8,
            }}>
              <p style={{
                fontFamily: "'Barlow', sans-serif", fontSize: 13, fontWeight: 700,
                letterSpacing: "0.1em", color: BRAND.navy, marginBottom: 12, textTransform: "uppercase",
              }}>The Three Layers Unified</p>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {[
                  { icon: "☧", label: "Past", sub: "Ancient standard of faith" },
                  { icon: "Dx", label: "Purpose", sub: "Medical decision science" },
                  { icon: "▊▊▊", label: "Platform", sub: "Genomic & diagnostic data" },
                ].map(item => (
                  <div key={item.label} style={{
                    flex: "1 1 140px", background: BRAND.offWhite,
                    borderRadius: 10, padding: "16px 18px", textAlign: "center",
                    border: `1px solid ${BRAND.lightGray}`,
                  }}>
                    <div style={{
                      fontFamily: "'Playfair Display', serif", fontSize: 22,
                      color: BRAND.gold, marginBottom: 6,
                    }}>{item.icon}</div>
                    <div style={{
                      fontFamily: "'Barlow', sans-serif", fontSize: 12, fontWeight: 700,
                      color: BRAND.navy, letterSpacing: "0.08em",
                    }}>{item.label}</div>
                    <div style={{
                      fontFamily: "'Barlow', sans-serif", fontSize: 11,
                      color: BRAND.textMid, marginTop: 4,
                    }}>{item.sub}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Divider />

          {/* Closing */}
          <div style={{ marginBottom: 0 }}>
            <SECTION_LABEL>Our Mission</SECTION_LABEL>
            <SectionHeading>We Are the Rebels</SectionHeading>
            <BodyText>
              The Labarium mark does not choose between faith and science. It insists they belong together.
            </BodyText>
            <BodyText>
              Constantine's labarum was a standard carried into battle against an entrenched empire. Labarium Diagnostic Systems carries its own standard into battle against the entrenched duopoly of Quest Diagnostics and LabCorp — two companies that have dominated independent laboratory services in the United States for decades. These two companies have devalued laboratory testing and halted innovation.
            </BodyText>
            <BodyText>
              <strong style={{ color: BRAND.navy }}>Labarium will revolutionize this industry.</strong>
            </BodyText>

            {/* Final statement */}
            <div style={{
              background: `linear-gradient(150deg, ${BRAND.navyDeep}, ${BRAND.navyDark})`,
              borderRadius: 20, padding: "52px 52px",
              textAlign: "center", marginTop: 48,
              position: "relative", overflow: "hidden",
            }}>
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, transparent, ${BRAND.gold}, transparent)` }} />
              <div style={{ position: "absolute", bottom: -60, left: "50%", transform: "translateX(-50%)", width: 300, height: 300, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,169,110,0.07) 0%, transparent 65%)" }} />
              <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{
                  fontFamily: "'Playfair Display', serif", fontStyle: "italic",
                  fontSize: "clamp(22px, 3.5vw, 36px)", color: BRAND.white,
                  lineHeight: 1.4, marginBottom: 16,
                }}>
                  "We are the rebels."
                </div>
                <div style={{
                  fontFamily: "'Playfair Display', serif", fontStyle: "italic",
                  fontSize: "clamp(18px, 2.5vw, 28px)", color: BRAND.gold,
                  lineHeight: 1.4,
                }}>
                  "The mark is our shield."
                </div>
              </div>
            </div>
          </div>

          {/* Footer nav */}
          <div style={{ marginTop: 72, paddingTop: 40, borderTop: `1px solid ${BRAND.lightGray}`, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
            <div>
              <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 4 }}>PUBLISHED</div>
              <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid }}>May 15, 2026 · Labarium Diagnostic Systems, Inc.</div>
            </div>
            <button
              onClick={() => setPage("newsroom")}
              style={{
                display: "inline-flex", alignItems: "center", gap: 10,
                background: BRAND.navy, color: BRAND.white,
                border: "none", borderRadius: 10,
                padding: "12px 24px", cursor: "pointer",
                fontFamily: "'Barlow', sans-serif", fontWeight: 700,
                fontSize: 12, letterSpacing: "0.1em",
              }}
              onMouseEnter={e => e.currentTarget.style.background = BRAND.navyDark}
              onMouseLeave={e => e.currentTarget.style.background = BRAND.navy}
            >
              ← ALL ARTICLES
            </button>
          </div>

        </div>
      </div>
    </>
  );
}
